import React, {useRef, useState} from "react";
import "./chooseFile.scss";
import {ReactComponent as SelectedIcon} from "../../assets/icons/Selected.svg";
import axios from "axios";
import PropTypes from "prop-types";
import {FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {ReactComponent as SampleCallImage} from "../../assets/images/SampleCall.svg";
import {ReactComponent as CustomerSupportCallImage} from "../../assets/images/CustomerSupportCall.svg";
import {SAMPLE_FILES} from "../../constants";


const IMAGE_COMPONENT = {
    SALES_CALL : SampleCallImage,
    CUSTOMER_SUPPORT_CALL : CustomerSupportCallImage
}
const ChooseFile = ({onCustomFileSelected, onSampleFileSelected, selectedFileName, selectedSampleFileName, showOptionToChooseCustomFile, label="", options=SAMPLE_FILES}) => {

    const inputField = useRef();

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (file && file.type.startsWith('audio/')) {
            onCustomFileSelected(file);
        } else {
            event.target.value = null;
            alert('Please select an audio file.');
        }
    };

    const triggerInputChange = (e) => {
        e.preventDefault();
        e.stopPropagation();
        inputField.current.click()
    }

    const handleChange = (event) => {
        const sampleFileSelected = event.target.value;
        console.log("in choose file code --------------------",sampleFileSelected)
        onSampleFileSelected(sampleFileSelected)
    };

    return <div className={"choose-file-container"}>
        {
            showOptionToChooseCustomFile && <div>
                <p className={"sub-text"}>Start by uploading your call:</p>
                <input type="file" onChange={handleFileChange} className={"file-upload-input"} ref={inputField}/>
                {
                    !!selectedFileName ? <div className={"gradient-border-container file-selected"}><div className={"option"}>
                            <p>{selectedFileName}</p>
                            <SelectedIcon />
                        </div></div>
                        : <div className={"gradient-border-container"}>
                            <button className="option choose-file" onClick={triggerInputChange}>
                            <p>Choose File</p>
                        </button>
                        </div>
                }
            </div>
        }
        <p className={"sub-text"}>{ showOptionToChooseCustomFile ? 'Or choose a sample call:' : label}</p>
        <FormControl>
            <RadioGroup
                aria-labelledby="choose-sample-file"
                name="choose-sample-file"
                className={"sample-files"}
                value={selectedSampleFileName}
                onChange={handleChange}
            >
                {
                    Object.values(options).map((option) => {
                        const ImageComponent = IMAGE_COMPONENT[option.key];
                        return (<div className={`gradient-border-container ${selectedSampleFileName === option.key ? 'selected' : ''}`} key={option.key}>
                            <div className="option" key={option.key}>
                                <div className={"radio-label-container"}>
                                    <FormControlLabel value={option.key} control={<Radio/>}/>
                                    <p><b>{option.name}</b><br/>{option.description}</p>
                                </div>
                                    {ImageComponent && <ImageComponent className={"sample-file-image"}/>}
                            </div>
                        </div>)
                    })
                }
            </RadioGroup>
        </FormControl>
 </div>

}

export default ChooseFile;

ChooseFile.prototype = {
    selectedFileName: PropTypes.string,
    selectedSampleFileName: PropTypes.string,
    onCustomFileSelected: PropTypes.func,
    onSampleFileSelected: PropTypes.func
}